





















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from '@/common/config';
import fetch from '@/common/api/fetch';
@Component
export default class NoticeModal extends Vue {
  @Prop() show!: boolean;
  @Prop() type!: string;

  @Getter('mainTextColor') mainTextColor!: string;
  activityType: string = getActivityType();
  enterType: string = getUrlParam('enterType') as string;
  XMCounter: boolean = true;
  mounted() {
    this.checkUserPermission();
  }
  handleOk() {
    this.$emit('cancel');
    if (this.type === 'xmPay') {
      window.open(
        'https://xopen.yuque.com/staff-sbg9na/xiaomai/anqyuggwzsnez3kr'
      );
    } else if (this.type === 'weChat') {
      if (this.XMCounter) {
        let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
        fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: getUrlParam('instId') }).then((res: any) => {
          location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/wechatNotice?channelStatusDetail=${JSON.stringify(res.result)}${
            this.enterType ? `&enterType=${this.enterType}` : ''
          }`;
        });
        parent.postMessage(
          {
            value: true,
            action: "linkToWechatNotice"
          },
          "*"
        );
      } else {
        Vue.$toast.error('无【小麦收银】权限，请联系管理员（主账号）');
      }
    }
  }

  handleCancel() {
    this.$emit('cancel');
  }
  checkUserPermission() {
    if (getUrlParam('instId') && getUrlParam('aid')) {
      const param = {
        instId: getUrlParam('instId'),
        adminId: getUrlParam('aid'),
        groupCode: 'XMCounter'
      };
      fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
        this.XMCounter = res.result;
      });
    } else {
      this.XMCounter = true;
    }
  }
}
